module.exports = __webpack_public_path__ + "static/img/5427_phase_function_Paper_PointsHejduk_Prediction.923b831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5427_phase_function_Paper_PointsHejduk_Prediction.png
// module id = zAV6
// module chunks = 0